/**
 * Re-export the languages list and default locale so that it can be more
 * easily used in the code.
 */
// eslint-disable-next-line import/extensions -- ESM module; Node scripts import the same file as .mjs
import locales from './localesForScripts.mjs';

export const DEFAULT_LOCALE = locales.DEFAULT_LOCALE;

export const LOCALES_LIST = locales.LOCALES_LIST;
